import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BaseLayout } from '../../../components';
import { AccountForm } from '../../../components/forms/account-form';
import { FORM_MODES } from '../../../constants/form.constants';

export const Route = createFileRoute('/accounts/add/')({
  component: AddAccount,
});

function AddAccount() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate({ to: '/dashboard' });
  };

  const handleCancel = () => {
    navigate({ to: '/dashboard' });
  };

  return (
    <BaseLayout
      header={{
        headerText: 'Add Account',
      }}
      breadcrumbs={{
        showBreadcrumbs: true,
        breadcrumbText: ['Accounts', 'Add Account'],
      }}
    >
      <AccountForm
        mode={FORM_MODES.ADD}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </BaseLayout>
  );
}
